import React, { useEffect, useRef } from 'react';
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const CategoriesList = () => {
    const { slug } = useParams();
    const categories = useSelector((state) => state.category.data);

    const activeRef = useRef(null);

    useEffect(() => {
        if (activeRef.current) {
        activeRef.current.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest',
        });
        }
    }, [slug]);

    return (
        <div className='categories-list'>
            <div className="container">
                <ul className='flex flex-align-center'>
                    {categories?.map((category) => {
                        const isActive = slug === category?.id;

                        return (
                        <li key={category?.id} ref={isActive ? activeRef : null}>
                            <Link
                                to={`/categories/${category?.id}`}
                                className={isActive ? 'active' : ''}
                            >
                                {category?.title}
                            </Link>
                        </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}

export default CategoriesList;